import React from 'react';
import { FileText } from 'lucide-react';
import SurchargeAgreementsList from './SurchargeAgreementsList';

interface Agreement {
  id: string;
  agreementName?: string;
  maxRate?: number;
  maxFlat?: number;
  fileName: string;
  uploadedAt: number;
  uploadedBy?: string;
  sizeBytes?: number;
  effectiveDate?: string;
  version?: string;
  status: 'active' | 'archived';
}

interface Props {
  tenantId: string;
  locationId: string;
  gateway: any;
  onSaved: () => void;
}

const SurchargeAgreementsCard: React.FC<Props> = ({ tenantId, locationId, gateway, onSaved }) => {
  const agreements: Agreement[] = Array.isArray(gateway?.surchargeAgreements) ? gateway.surchargeAgreements : [];
  const activeAgreementId: string | null = gateway?.activeSurchargeAgreementId || null;

  return (
    <div id="surcharge-agreements" className="bg-white rounded-2xl shadow-sm border border-stone-200/60 p-5">
      <div className="flex items-center gap-3 mb-1">
        <div className="w-9 h-9 rounded-lg bg-stone-900 flex items-center justify-center shrink-0">
          <FileText size={16} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <h3 className="font-semibold text-sm text-stone-800">Surcharge Agreements</h3>
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200 font-medium">Location-wide</span>
          </div>
          <p className="text-xs text-stone-500 mt-0.5">
            Upload signed surcharge agreements (PDF) and their max rate / flat ceilings here.
            Agreements apply to every terminal at this location and must exist before surcharge can be enabled on Card Processing.
          </p>
        </div>
      </div>

      <div className="mt-4">
        <SurchargeAgreementsList
          tenantId={tenantId}
          locationId={locationId}
          agreements={agreements}
          activeAgreementId={activeAgreementId}
          onChanged={onSaved}
          standalone
        />
      </div>
    </div>
  );
};

export default SurchargeAgreementsCard;
